import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

import { SupplierPortalDocumentsComponent } from '../supplier-portal-documents/supplier-portal-documents.component'
import { SupplierPortalDocumentScope } from '../supplier-portal-document-type.util'

// Wrapper fino de dialog em torno de SupplierPortalDocumentsComponent — usado quando
// não há um formulário de edição já aberto (ex.: ícone "Documentos" na listagem das
// modais de atribuir). O grosso da lógica mora no componente embutível, reaproveitado
// também dentro de modal-driver-edit / modal-vehicle-edit.
@Component({
  selector: 'modal-supplier-portal-documents',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, SupplierPortalDocumentsComponent],
  templateUrl: './modal-supplier-portal-documents.component.html',
  styleUrl: './modal-supplier-portal-documents.component.scss',
})
export class ModalSupplierPortalDocumentsComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { escopo: SupplierPortalDocumentScope; ownerId: number | string; titulo: string },
    private dialogRef: MatDialogRef<ModalSupplierPortalDocumentsComponent>,
  ) {}

  close(): void { this.dialogRef.close() }
}
